// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__2Th_T","warning":"Login_warning__LZ9pv"};